import React from 'react'

export const presets = {
  szenarios: [
    {
      data: {
        roomVolume: 300,
        airExchangeRate: 1.5,
        timeInRoom: 180,
        maskEfficiencyExhaled: 0,
        maskEfficiencyInhaled: 0,
        emitterType: 'very',
        activityLevel: 'low',
        voiceStrengths: [0.4, 0.5, 0.1],
        criticalDose: 500
      },
      name: 'Restaurant',
      desc: '',

      icon: 'party',
      text: (
        <>
          Das Restaurant fasst etwa <b>300m³</b> und wird{' '}
          <b>von einer starken Lüftung</b> belüftet. Die Gäste benötigen für das
          Abendessen etwa <b>drei Stunden</b> und tragen dabei{' '}
          <b>keine Masken</b>. Die sitzenden Gäste sorgen für{' '}
          <b>wenig Aktivität</b>; die Gespräche in normaler Laustärke führen zu{' '}
          <b>mässiger Sprechaktivität</b>. Es ist eine{' '}
          <b>sehr ansteckende Person</b> im Raum anwesend.
        </>
      )
    },
    {
      data: {
        roomVolume: 50,
        airExchangeRate: 2,
        timeInRoom: 15,
        maskEfficiencyExhaled: 0.75,
        maskEfficiencyInhaled: 0.75,
        emitterType: 'very',
        activityLevel: 'medium',
        voiceStrengths: [1, 0, 0],
        criticalDose: 500
      },
      name: 'Wartezimmer',
      desc: 'beim Arzt',
      icon: 'doctor',
      text: (
        <>
          Das Wartezimmer einer Arztpraxis ist in der Regel nicht sehr gross –
          in diesem Beispiel misst es rund <b>50m³</b>. Dank regelmässigem{' '}
          <b>Stosslüften</b> wird die Luft zweimal pro Stunde vollständig
          ausgetauscht. Die wartenden Patienten verbringen im Schnitt{' '}
          <b>15 Minuten</b> im Raum und tragen alle handelsübliche{' '}
          <b>chirurgische Masken</b>. Das Kommen und Gehen von Patienten führt
          dazu, dass im Raum eine <b>mittlere Aktivität</b> herrscht. Fast
          niemand redet – dadurch bleibt das Niveau der{' '}
          <b>Sprechaktivität sehr tief</b>. Die Gefahr der Übertragung von
          Covid-19 geht von einem <b>sehr hoch ansteckenden</b> Emitter aus.
        </>
      )
    },
    {
      data: {
        roomVolume: 150,
        airExchangeRate: 6,
        timeInRoom: 45,
        maskEfficiencyExhaled: 0.75,
        maskEfficiencyInhaled: 0,
        emitterType: 'very',
        activityLevel: 'low',
        voiceStrengths: [0.4, 0.5, 0.1],
        criticalDose: 500
      },
      name: 'Schulzimmer',
      desc: 'im Unterricht',

      icon: 'school',
      text: (
        <>
          Das Schulzimmer misst rund <b>150m³</b> und wird durch{' '}
          <b>eine starke Lüftung</b> belüftet. Die Schülerinnen und Schüler
          tragen <b>keine Masken</b> und verbringen pro Lektion{' '}
          <b>45 Minuten</b> im Raum. Sie <b>bewegen sich wenig</b> während des
          Unterrichts, reden aber viel und in unterschiedlicher Lautstärke –
          dies führt zu einer relativ <b>hohen Sprechaktivität</b>. Die
          gefährlichen Aerosole werden von der{' '}
          <b>sehr hoch ansteckenden Lehrperson</b> ausgestossen, die eine{' '}
          <b>OP-Maske</b> tägt.
        </>
      )
    }
  ],
  szenarioSelectOptions: [
    { name: 'Warteraum', value: 0 },
    { name: 'Klassenzimmer', value: 1 },
    { name: 'Weihnachsfeier', value: 2 }
  ],
  parameters: {
    emitterType: [
        {
        name: 'Hoch',
        desc: 'Eine von drei Personen',
        value: 'high'
      },
      {
        name: 'Sehr hoch',
        desc: 'Eine von 10 Personen',
        value: 'very'
      },
      {
        name: 'Super',
        desc: 'Eine von 30 Personen',
        value: 'super'
      }
    ],
    criticalDose: [
      { name: 'Nicht besonders gefährdet', value: 500 },
      { name: 'Besonders gefährdet', value: 50 }
    ],
    roomVolume: [
      { name: '50m³', desc: 'z.B. Wartezimmer', value: 50 },
      { name: '100m³', desc: 'z.B. Laden', value: 100 },
      { name: '150m³', desc: 'z.B. Schulzimmer', value: 150 },
      { name: '300m³', desc: 'z.B. Restaurant', value: 300 },
      { name: '3000m³', desc: 'z.B. Supermarkt', value: 3000 }
    ],
    airExchangeRate: [
      { name: 'Nicht lüften', desc: '', value: 0.2 },
      { name: 'Stosslüften', desc: 'alle 30min', value: 2 },
      { name: 'Lüftung schwach', desc: 'wenige Personen / m²', value: 1.5 },
      { name: 'Lüftung stark', desc: 'viele Personen / m²', value: 6 }
    ],
    timeInRoom: [
      { name: '5 Minuten', value: 5 },
      { name: '15 Minuten', value: 15 },
      { name: '45 Minuten', value: 45 },
      { name: '90 Minuten', value: 90 },
      { name: '180 Minuten', value: 180 }
    ],
    maskEfficiencyExhaled: [
      { name: 'keine Maske', value: 0 },
      { name: 'Tuch', value: 0.25 },
      { name: 'OP-Maske', value: 0.75 },
      { name: 'FFP2', value: 0.8 }
    ],
    maskEfficiencyInhaled: [
      { name: 'keine Maske', value: 0 },
      { name: 'Tuch', value: 0.25 },
      { name: 'OP-Maske', value: 0.75 },
      { name: 'FFP2', value: 0.95 }
    ],
    activityLevel: [
      { name: 'Leicht', value: 'low' },
      { name: 'Mittel', value: 'medium' },
      { name: 'Stark', value: 'high' }
    ],
    voiceStrengths: [
      { name: 'Stumm', value: [1, 0, 0] },
      { name: 'Leise Sprechen, Flüstern', value: [0.9, 0.1, 0] },
      { name: 'Gespräch', value: [0.4, 0.5, 0.1] },
      { name: 'Singen', value: [0.3, 0, 0.7] }
    ]
  },
  parameterText: {
    criticalDose: {
      t: <>Sind Sie besonders gefährdet?</>,
      d: (
        <>
          Sind Sie über 60 Jahre alt, oder leiden Sie an Vorerkrankungen wie
          Bluthochdruck, Diabetes oder Krebs? Dann kann schon bei 50
          eingeatmeten Viren eine Ansteckung erfolgen – normalerweise liegt
          diese Schwelle bei ungefähr 500 Viren.
        </>
      )
    },
    roomVolume: {
      t: <>Wie gross ist der Raum?</>,
      d: (
        <>
          Je grösser das Volumen des Raumes, desto kleiner ist das
          Ansteckungsrisiko durch Aerosole: Die ausgeatmete Virenmenge verteilt
          sich besser, und das Abstandhalten wird vereinfacht.
        </>
      )
    },
    airExchangeRate: {
      t: <>Wie wird gelüftet?</>,
      d: (
        <>
          Eine für wenige Personen ausgelegte, starke mechanische Lüftung (z.B.
          in einem kleinen Laden) ersetzt die gesamte Luft eines Raumes 1,5-mal
          pro Stunde vollständig – eine für viele Besucher tut dies bis zu
          sechsmal pro Stunde (z.B. in einem Restaurant).
        </>
      )
    },
    timeInRoom: {
      t: <>Wie lang halten sich die Personen im Raum auf?</>,
      d: (
        <>
          Während dieser Zeit ist eine nicht infizierte Person den Aerosolen
          ausgesetzt, die von der gleichzeitig anwesenden, ansteckenden Person
          ausgeatmet werden.
        </>
      )
    },
    emitterType: {
      t: <>Wie ansteckend ist die im Raum anwesende infizierte Person?</>,
      d: (
        <>
          Die Ansteckungspotenzial einer infizierten Person ist unterschiedlich:
          Manche atmen viele Viren aus, andere weniger. Hohe Emitter sind
          zehnmal häufiger als sogenannte «Super-Emitter» – letztere stossen
          allerdings beim Reden die 322-fache Virenmenge aus.
        </>
      )
    },

    maskEfficiencyExhaled: {
      t: <>Welche Maske trägt die ansteckende Person?</>,
      d: (
        <>
          Bei der Maske der ansteckenden Person steht die Wirksamkeit bei der
          Ausatmung im Vordergrund. Diese reicht von 25% bei einer Stoffmaske
          bis zu 80% bei einer FFP2-Maske.
        </>
      )
    },
    maskEfficiencyInhaled: {
      t: <>Welche Masken tragen die nicht infizierten Personen?</>,
      d: (
        <>
          Bei den Masken der nicht infizierten Personen steht die Wirksamkeit
          bei der Einatmung im Vordergrund. Diese reicht von 25% bei einem
          einfachen Tuch bis zu 95% bei einer FFP2-Maske.
        </>
      )
    },
    activityLevel: {
      t: <>Wie sehr sind die Personen im Raum körperlich aktiv?</>,
      d: (
        <>
          Je grösser die Aktivität im Raum, desto mehr wird geatmet. Eine
          infizierte Person atmet mehr Viren aus, und die anderen Personen atmen
          mehr virenbelastete Luft ein.
        </>
      )
    },
    voiceStrengths: {
      t: <>Wie wird im Raum gesprochen bzw. gesungen?</>,
      d: (
        <>
          Sprechen versetzt die Atemluft in Bewegung. Dadurch werden in Lungen,
          Stimmbändern und Lippen mehr virenbelastete Aerosole gebildet und im
          Raum freigesetzt.
        </>
      )
    }
  },
  parameterOrder: [
    'criticalDose',
    'roomVolume',
    'timeInRoom',
    'emitterType',
    'airExchangeRate',
    'maskEfficiencyExhaled',
    'maskEfficiencyInhaled',
    'activityLevel',
    'voiceStrengths'
  ]
}
